import { Route, Routes } from 'react-router-dom';

import SignUp from './authentication/SignUp';
import Login from './authentication/Login';
import ForgotPassword from './authentication/ForgotPassword';
import VerifyOTP from './authentication/VerifyOTP';
import SendOTP from './authentication/SendOTP';
import Appmain from './components/partials/AppMain';
import NotFound from './components/NotFound';
import NewPassword from './authentication/NewPassword';
import PublicRoute from './authentication/PublicRoutes';
import PrivateRoute from './authentication/PrivateRoutes';
import Logout from './authentication/Logout';

function App() {
    return (
        <Routes>
            <Route path='/' element={
                <PublicRoute>
                    <SignUp />
                </PublicRoute>
            } />

            <Route path='/login' element={
                <PublicRoute>
                    <Login />
                </PublicRoute>
            } />

            <Route path='/verify-otp' element={
                <PublicRoute>
                    <VerifyOTP />
                </PublicRoute>
            } />

            <Route path='/forgot-password' element={
                <PublicRoute>
                    <ForgotPassword />
                </PublicRoute>
            } />

            <Route path='/send-otp' element={
                <PublicRoute>
                    <SendOTP />
                </PublicRoute>
            } />

            <Route path='/new-password' element={
                <PublicRoute>
                    <NewPassword />
                </PublicRoute>
            } />

            <Route path='/logout' element={<Logout />} />

            <Route path='/dashboard/*' element={
                <PrivateRoute>
                    <Appmain />
                </PrivateRoute>
            } />

            <Route path='/quotation/*' element={
                <PrivateRoute>
                    <Appmain />
                </PrivateRoute>
            } />

            <Route path='/vendor/*' element={
                <PrivateRoute>
                    <Appmain />
                </PrivateRoute>
            } />

            <Route path='/profile/*' element={
                <PrivateRoute>
                    <Appmain />
                </PrivateRoute>
            } />

            <Route path='/password/*' element={
                <PrivateRoute>
                    <Appmain />
                </PrivateRoute>
            } />


            <Route path='*' element={<NotFound />} />
        </Routes>
    );
}

export default App;
